export default __webpack_public_path__ + "static/media/20.8b440881.jpg";